import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/contractGroup', request)
}

async function post(request) {
    return await postMethod('/api/contractGroup', request)
}

async function put(request) {
    return await putMethod('/api/contractGroup', request)
}

export {get, post, put}
